<template>
  <div class="white-bg common-container">
    <div class="wrap company-project">
      <h2 class="public-title">项目介绍</h2>
      <el-row justify="center" class="hidden-sm-and-down">
        <el-col :md="4" :sm="4" @mouseover="switchTab(index)" @mouseout="autoPlayFun"
          v-for="(tabItem,index) in projectTab" :key="index">
          <div class="pro-tab-con">
            <div class="project-icon">
              <img v-show="index!=introInd" :src="require('@/assets/images/icon/'+tabItem.icon)" alt="">
              <img v-show="index==introInd" :src="require('@/assets/images/icon/'+tabItem.iconActive)" alt="">
            </div>
            <span>{{tabItem.name}}</span>
          </div>
        </el-col>
      </el-row>
      <div class="project-carousel">
        <el-carousel height="675px" @change="changeFun" ref="projectRef" :autoplay="proAutoPlay" arrow="never" interval="5000">
          <el-carousel-item v-for="item in projectContent" :key="item" name="index">
            <div class="project-content">
              <img :src="require('@/assets/images/img/'+item.imgSrc)" alt="">
              <div class="project-detail">
                <h4 class="project-name">{{item.name}}</h4>
                <p>{{item.detail}}</p>
              </div>
            </div>

          </el-carousel-item>
          <!-- 撑起el-carousel__containe -->
          <div style="height:675px;"></div>
        </el-carousel>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive } from "vue";
export default defineComponent({
  setup() {
    const projectRef = ref(); //项目介绍Dom
    let introInd = ref(0); //项目介绍滑动索引
    let proAutoPlay = ref(true); //项目介绍是否自动切花
    //项目介绍tab
    const projectTab = reactive([
      {
        icon: "ic_item_ky_default.png",
        iconActive: "ic_item_ky_click.png",
        name: "文都考研"
      },
      {
        icon: "ic_item_yk_default.png",
        iconActive: "ic_item_yk_click.png",
        name: "文都医考"
      },
      {
        icon: "ic_item_jk_default.png",
        iconActive: "ic_item_jk_click.png",
        name: "文都建考"
      },
      {
        icon: "ic_item_fk_default.png",
        iconActive: "ic_item_fk_click.png",
        name: "文都法考"
      },
      {
        icon: "ic_item_gk_default.png",
        iconActive: "ic_item_gk_click.png",
        name: "文都公考"
      }
    ]);
    //项目介绍tab对应内容
    const projectContent = reactive([
      {
        imgSrc: "img_kaoyan.jpg",
        name: "文都考研",
        detail:
          "文都考研由考研公共课、考研专业课、专业硕士、考研高端辅导、考研集训营、MBA辅导等项目组成。师资团队由全国考研业界一线辅导名师组成，授课师资对阅卷和命题规律有着深刻的了解，本着由浅入深、由一般到综合、循序渐进的科学授课原则，使文都考研成为考研培训领域知名品牌。"
      },
      {
        imgSrc: "img_yikao.jpg",
        name: "文都医考",
        detail:
          " 文都医考多年来致力于国家执业医师(含助理)、国家执业药师、全国护士执业资格考试、全国卫生专业技术资格考试培训项目的研究。其精致、高效的培训已覆盖全国二十多个省(市、自治区)，建设有三百多个终端教学中心，开展面授、远程、网络等多种授课形式，以满足不同学员多样化的选择。"
      },
      {
        imgSrc: "img_jiankao.jpg",
        name: "文都建考",
        detail:
          "文都建设工程考试研究中心，简称文都建考，是致力于一级、二级建造师、消防工程师、造价工程师等多种执业资格考试的专业培训教学研究机构。为建筑类企业提供专业建筑岗位人员培训，还包括为继续教育及工程师评审服务。 为学员提供学历优化提升增设了学历教育中心，通过多媒体远程教育、成人高考、自考等多种形式提升学员的学历，为实现就业梦想保驾护航。"
      },
      {
        imgSrc: "img_fakao.jpg",
        name: "文都法考",
        detail:
          "文都集团全资收购的中律司考，主要从事司法考试、法律(法学)硕士、律师实务等法律相关业务培训，“5S”教学管理品质，以过关为导向，树立高端旗帜，打造业内良心机构。坚守“品质高端化、教学特色化、项目进阶化”发展理念，定位在“课程(超细化合理安排)+名师(互补式强强师资组合)+图书(减负精品配套丛书)+特色(家教式教辅模式)”。"
      },
      {
        imgSrc: "img_gongkao.jpg",
        name: "文都公职",
        detail:
          "文都公职考试培训涵盖所有公务员考试、教师资格考试和教师招聘/特岗教师考试培训，集师资开发、考生服务、教学教研、产品研发、已经形成了以面授、网络课堂直播、录播、图书和高端辅导多位一体的辅导体系，独创了全程服务理念、递进式阶梯教学系统，一直致力于提高考生的通过率，并且在业内取得了骄人的成绩。是广大考生备考不可缺少的“好帮手”。"
      }
    ]);
    // 项目介绍轮播
    const changeFun = e => {
      introInd.value = e;
    };
    // 鼠标移入 切换项目介绍
    const switchTab = index => {
        proAutoPlay.value = false;
      projectRef.value.setActiveItem(index);
    };
    // 鼠标移出 自动切换
    const autoPlayFun = () => {
        setTimeout(()=>{
            proAutoPlay.value = true;
        },5000)
      
    };

    return {
      projectRef,
      introInd,
      proAutoPlay,
      projectTab,
      projectContent,
      changeFun,
      switchTab,
      autoPlayFun
    };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.company-project {
  .pro-tab-con {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    cursor: pointer;
  }
  .project-icon {
    width: 48px;
    height: 48px;
    margin: 0 auto 24px;
    img {
      width: 48px;
      height: 48px;
    }
  }
  .project-carousel {
      height:675px;
    margin-bottom: 40px;
    img {
      width: 100%;
    }
  }
  /deep/ .el-carousel__container {
    height: auto !important;
  }
   /deep/ .el-carousel__indicators {
    display: none;
  }
  .project-content {
    position: relative;
    .project-detail {
      position: absolute;
    //   bottom: 40px;
      left: 5%;
      width: 90%;
      padding: 24px 40px;
      background: #fff;
      box-sizing: border-box;
      font-size: 14px;

      h4 {
        font-size: 20px;
        margin-bottom: 16px;
      }
      p {
        color: #869099;
      }
    }
  }
}
</style>
<style lang="css">
    @keyframes mymove
    {
        from {bottom:0px;}
        to {bottom:40px;}
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/
    {
        from {bottom:0px;}
        to {bottom:40px;}
    }
    .el-carousel .is-active .project-detail{
        animation:mymove 1s;
        -webkit-animation:mymove 1s;
       animation-iteration-count:1; /*播放一次 */
        animation-fill-mode:forwards;  /*保持最后一个状态*/
    }
</style>
